import type { TAnswers } from 'models/common.model'
import {
  GETS_OVERLY_EXCITED_OPTION,
  IGNORES_COMMANDS_OPTION,
  REACTS_TO_PEOPLE_OR_DOGS_OPTION,
} from '../pages/questions/DuringWalkQuestion'

export const getImplicitBehaviorIssuesK9BlBG = (
  savedAnswers: Partial<TAnswers> | null | undefined,
): string[] => {
  if (!savedAnswers) return []

  const leashRaw = savedAnswers.leash_pulling_k9_bl_bg
  const leash = Array.isArray(leashRaw) ? leashRaw[0] : leashRaw
  const walkArr = Array.isArray(savedAnswers.during_walk_k9_bl_bg)
    ? savedAnswers.during_walk_k9_bl_bg
    : []

  return [
    ...(leash === 'yes' || leash === 'sometimes' ? ['leash_pulling'] : []),
    ...(walkArr.includes(IGNORES_COMMANDS_OPTION) ? ['ignoring_commands'] : []),
    ...(walkArr.includes(GETS_OVERLY_EXCITED_OPTION) ? ['hyper_energy'] : []),
    ...(walkArr.includes(REACTS_TO_PEOPLE_OR_DOGS_OPTION)
      ? ['reactivity']
      : []),
  ]
}
